import Inputmask from "inputmask";

import NotificationManager from "../utils/class/notifications";
import Validation from "./_validation";

import debounce from "../utils/debounce";

export default class Form {
    constructor (query) {
        const form = document.querySelector(query);
        if (!form) return;

        const fields = form.querySelectorAll('.site-field');
        if (!fields || !fields.length) throw new Error('Form fields not found');

        const submit = form.querySelector('button[type="submit"]');

        this.NotificationManager = new NotificationManager();

        this.form = form;
        this.nosubmit = form.classList.contains('nosubmit');
        this.fields = [...fields];
        this.submit = submit || undefined;

        this.init();
    }

    init () {
        this.fields.forEach((field) => {
            const { type } = field.dataset;

            const required = field.dataset.required === 'true';

            this.handleField(field, type, required);
        });

        this.handleSubmit();
        this.handleNoSubmit();
    }

    handleField (field, type, required) {
        const input = field.querySelector('input, textarea');

        const hint = field.querySelector('.site-field--hint');

        const validation = new Validation(field, hint, type, required);

        if (type !== 'checkbox') {
            input.addEventListener('input', () => {
                switch (type) {
                    case 'name':
                        validation.validateRequired(input.value);
                        validation.validateName(input.value);
                    break;
                    case 'email':
                        validation.validateRequired(input.value);
                        validation.validateEmail(input.value);
                    break;
                    case 'phone':
                        validation.validateRequired(input.value);
                        validation.validatePhone(input.value);
                    break;
                    case 'card':
                        validation.validateRequired(input.value);
                        validation.validateCard(input.value);
                    break;
                    case 'password':
                        validation.validateRequired(input.value);
                        validation.validatePassword(
                            input.value,
                            this.form.querySelector('#password-confirmation') ? this.form.querySelector('#password-confirmation').value : null
                        );
                    break;
                    case 'password-confirmation':
                        validation.validateRequired(input.value);
                        validation.validatePasswordConfirmation(
                            input.value,
                            this.form.querySelector('#password') ? this.form.querySelector('#password').value : null
                        );
                    break;
                    case 'number':
                        validation.validateRequired(input.value);
                        validation.validateNumber(input.value);
                    break;
                    case 'number-min':
                        validation.validateRequired(input.value);
                        validation.validateNumberMin(input.value, input.dataset.min);
                    break;
                    case 'user':
                        validation.validateRequired(input.value);
                        validation.validateUser(input.value);
                    break;
                    case 'title':
                        validation.validateRequired(input.value);
                        validation.validateTitle(input.value);
                    break;
                    case 'description':
                        validation.validateRequired(input.value);
                        validation.validateDescription(input.value);
                    break;
                    case 'details':
                        validation.validateRequired(input.value);
                        validation.validateDetails(input.value);
                    break;
                    case 'rating':
                        validation.validateRating(input.value);
                    break;
                    case 'time':
                        validation.validateTime(field);
                    break;
                    default:
                        validation.validateRequired(input.value);
                    break;
                }
            });

            if (type === 'password' || type === 'password-confirmation') this.handlePasswordToggle(field, input);

            if (type === 'card') {
                new Inputmask({ mask: '9999 9999 9999 9999' }).mask(input);
            };

            if (type === 'sort-code') {
                new Inputmask({ mask: '9 9 - 9 9 - 9 9' }).mask(input);
            };

            if (type === 'account-number') {
                new Inputmask({ mask: '9 9 9 9 9 9 9 9' }).mask(input);
            };

            if (type === 'iban') {
                new Inputmask({ mask: 'AA 99 AAAA 999999 99999999' }).mask(input);
            };

            if (type === 'swift') {
                new Inputmask({ mask: 'AAAA - AA - AA - 999' }).mask(input);
            };
        } else {
            input.addEventListener('change', () => {
                validation.validateRequired(input.checked);
            });
        }
    }

    validateFields (specific = [], hints = true) {
        const target = specific.length ? specific : this.fields;

        target.forEach((field) => {
            const { type } = field.dataset;

            const required = field.dataset.required === 'true';

            const input = field.querySelector('input, textarea');
            const hint = field.querySelector('.site-field--hint');

            const validation = new Validation(field, hint, type, required, hints);

            switch (type) {
                case 'name':
                    validation.validateRequired(input.value);
                    validation.validateName(input.value);
                break;
                case 'email':
                    validation.validateRequired(input.value);
                    validation.validateEmail(input.value);
                break;
                case 'phone':
                    validation.validateRequired(input.value);
                    validation.validatePhone(input.value);
                break;
                case 'card':
                    validation.validateRequired(input.value);
                    validation.validateCard(input.value);
                break;
                case 'password':
                    validation.validateRequired(input.value);
                    validation.validatePassword(
                        input.value,
                        this.form.querySelector('#password-confirmation') ? this.form.querySelector('#password-confirmation').value : null
                    );
                break;
                case 'password-confirmation':
                    validation.validateRequired(input.value);
                    validation.validatePasswordConfirmation(
                        input.value,
                        this.form.querySelector('#password') ? this.form.querySelector('#password').value : null
                    );
                break;
                case 'number':
                    validation.validateRequired(input.value);
                    validation.validateNumber(input.value);
                break;
                case 'number-min':
                    validation.validateRequired(input.value);
                    validation.validateNumberMin(input.value, input.dataset.min);
                break;
                case 'user':
                    validation.validateRequired(input.value);
                    validation.validateUser(input.value);
                break;
                case 'title':
                    validation.validateRequired(input.value);
                    validation.validateTitle(input.value);
                break;
                case 'description':
                    validation.validateRequired(input.value);
                    validation.validateDescription(input.value);
                break;
                case 'details':
                    validation.validateRequired(input.value);
                    validation.validateDetails(input.value);
                break;
                case 'checkbox':
                    validation.validateRequired(input.checked);
                break;
                case 'rating':
                    validation.validateRating(field);
                break;
                case 'time':
                    validation.validateTime(field);
                break;
                default:
                    validation.validateRequired(input.value);
                break;
            }
        });

        if (specific.length) {
            return !specific.some((field) => !!field.dataset.error);
        }

        return !this.fields.some((field) => !!field.dataset.error);
    }

    handlePasswordToggle (field, input) {
        const toggle = field.querySelector('.site-field--password-toggle');

        toggle.addEventListener('click', (event) => {
            event.stopPropagation();

            const type = input.getAttribute('type');

            if (type === 'password') input.setAttribute('type', 'text');
            if (type === 'text') input.setAttribute('type', 'password');

            toggle.classList.toggle('active');
        });
    }

    handleSubmit () {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();

            const valid = this.validateFields();

            if (valid) this.finalizeForm();
        });
    }

    handleNoSubmit () {
        const gthis = this;

        if (!this.nosubmit) return;

        const fields = this.form.querySelectorAll('input');
        if (!fields || !fields.length) return;

        const handler = debounce(function () {
            const valid = gthis.validateFields();

            if (valid) gthis.finalizeForm();
        }, 300);

        [...fields].forEach((field) => {
            field.addEventListener('change', handler);
        });
    }

    finalizeForm () {
        console.log('Sent');
    }
}
